const cartItemTemplate = (props = {}) => {
  const {
    id = 0,
    line_number = false,
    image = "",
    price = 0,
    product_title = "",
    quantity = 1,
    vendor = "",
    url = "",
    options_with_values = [],
    properties = {},
  } = props;

  let options = [];
  if (options_with_values.length) {
    options_with_values.forEach((option) =>
      options.push(`<div>${option.name}: ${option.value}</div>`)
    );
  }

  return `<li class="cart-drawer__item">
    <a href="${url}" class="cart-drawer__item__image__container" aria-label="${product_title}">
      <div class="cart-drawer__item__image">
        <img src="${image}" alt="${product_title}">
      </div>
    </a>
    <div class="cart-drawer__item-content">
      <div class="cart-drawer__item__title">
        <div>${vendor}</div>
        <div>${product_title}</div>
        <div>
          ${options.length ? options.join("") : ""}
        </div>
      </div>
    </div>
  </li>`;
};

const cartTemplate = (props = {}) => {
  const { item_count = 0, items = [], total_price = 0 } = props;

  const output = `
    <div class="cart-drawer">
      <div class="cart-drawer__header">
        ${item_count === 0 ? "Your cart is empty" : "Added To Cart"}
      </div>
      ${
        item_count === 0
          ? ""
          : `<ul class="cart-drawer__items">
          ${items.map(cartItemTemplate).join("")}
        </ul>`
      }
      <div class="cart-drawer__button">
        ${
          item_count === 0
            ? `<button class="button js-cartClose" aria-label="Close Cart">Keep Shopping</button>`
            : `<a href="/cart" class="button">Checkout</a>`
        }
      </div>
    </div>
  `;

  return output;
};

export default cartTemplate;
